import Timeline from "../shared/Timeline";

export default function Timeslines({ item }: { item: any }) {
  const events = item?.events ?? [
    {
      activity: "Buying from Farmer",
      date: "2021-09-01",
      done_by: "John Doe",
    },
    {
      activity: "Transporting to Warehouse",
      date: "2021-09-02",
      done_by: "John Doe",
    },
    {
      activity: "Processing",
      date: "2021-09-03",
      done_by: "John Doe",
    },
    {
      activity: "Packaging",
      date: "2021-09-04",
      done_by: "John Doe",
    },
    {
      activity: "Shipping",
      date: "2021-09-05",
      done_by: "John Doe",
    },
    {
      activity: "Completed",
      date: "2021-09-06",
      done_by: "John Doe",
    },
  ];

  return (
    <div className="mx-2 my-4 relative p-3" id="timeline">
      <Timeline data={events} />
    </div>
  );
}
